export default function auth({ next, to }) {
  const rawSession = localStorage.getItem('session') || sessionStorage.getItem('session')
  if (!rawSession) {
    return next({ name: 'auth-login' })
  }
  const session = JSON.parse(rawSession)
  if (session?.user?.must_change_password && to.name !== 'profile') {
    return next({ name: 'profile', query: { change_password: '1' } })
  }
  return next()
}
